import { render } from "./thirdPartySettings.vue?vue&type=template&id=605835c0&scoped=true"
import script from "./thirdPartySettings.vue?vue&type=script&lang=js"
export * from "./thirdPartySettings.vue?vue&type=script&lang=js"

import "./thirdPartySettings.vue?vue&type=style&index=0&id=605835c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605835c0"]])

export default __exports__